export default function getRecaptchaV3Token() {
  return new Promise((resolve, reject) => {
    const rejectRecaptcha = () =>
      reject(new Error('Recaptcha failed'));

    const captcha = window.grecaptcha;

    if (!captcha) {
      rejectRecaptcha();
      return;
    }

    try {
      captcha.ready(() => {
        try {
          captcha
            .execute(process.env.REACT_APP_RECAPTCHA_KEY_V3, {
              action: 'signUp',
            })
            .then(resolve, rejectRecaptcha);
        } catch {
          rejectRecaptcha();
        }
      });
    } catch {
      rejectRecaptcha();
    }
  });
};